// src/admin/AdminLayout.js
import React from "react";
import { Outlet } from "react-router-dom";
import { AdminLanguageProvider } from "./context/AdminLanguageContext";

function AdminLayout() {
  return (
    <AdminLanguageProvider>
      {/* provider will set dir on this wrapper */}
      <div id="admin-root">
        <Outlet />
      </div>
    </AdminLanguageProvider>
  );
}

export default AdminLayout;
